import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import humanTime from 'flarum/common/helpers/humanTime';
import { api, go, logo, verifiedText, statusLabel, VOUCH_NOTE } from './util';
const person = u => u.avatarUrl ? m("img", {
  className: "Avatar",
  src: u.avatarUrl,
  alt: "",
  loading: "lazy"
}) : m("span", {
  className: "Avatar VBiz-avatar"
}, String(u.username || '?')[0].toUpperCase());

/**
 * /businesses/{slug}: a business's page, laid out like an event's. A bar (back, copy link, edit), the logo beside
 * the name and its facts (industry, years, verification), a Vouch card, then About (what it does, services,
 * products, areas), Contact, People, Updates (discussions its people posted for it) and Vouches. Owners also
 * manage the team at the bottom.
 */
export default class BusinessView extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.slug = m.route.param('slug');
    this.b = null;
    this.error = null;
    this.posts = null;
    this.mine = null; // the member's own discussions, to post one as an update
    this.note = '';
    this.inviteName = '';
    this.inviteRole = 'team';
    this.msg = null;
    this.load();
  }
  load() {
    app.request({
      method: 'GET',
      url: api('/businesses/' + this.slug) + (this.counted ? '' : '?visit=1'),
      errorHandler: () => {}
    }).then(r => {
      this.counted = true; // one visit per page view, not per reload after an action
      this.got(r);
    }).catch(e => this.error = e && e.response && e.response.message || 'This business could not be found.').then(() => m.redraw());
  }
  got(r) {
    if (r && r.business) {
      this.b = r.business;
      app.setTitle(this.b.name);
      if (this.posts === null) this.loadPosts();
    }
  }
  loadPosts() {
    this.posts = undefined;
    app.store.find('discussions', {
      filter: {
        vouchaBusiness: String(this.b.id)
      },
      sort: '-createdAt',
      page: {
        limit: 10
      },
      include: 'user'
    }).then(list => this.posts = list || []).catch(() => this.posts = []).then(() => m.redraw());
  }
  act(method, path, body, done) {
    this.busy = path;
    this.msg = null;
    return app.request({
      method,
      url: api('/businesses/' + this.b.id + path),
      body,
      errorHandler: () => {}
    }).then(r => {
      if (r && r.business) this.got(r);
      if (done) done(r);
    }).catch(e => this.msg = e && e.response && e.response.message || 'That didn’t work. Please try again.').then(() => {
      this.busy = null;
      m.redraw();
    });
  }
  copy() {
    const url = window.location.origin + '/businesses/' + this.b.slug;
    const done = () => {
      this.copied = true;
      m.redraw();
      setTimeout(() => (this.copied = false, m.redraw()), 2000);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, () => window.prompt('Copy this link', url));else window.prompt('Copy this link', url);
  }
  view() {
    if (this.error) {
      return m("div", {
        className: "VEvt VEvt-empty"
      }, m("p", null, this.error), m("a", {
        href: "/businesses",
        onclick: go('/businesses')
      }, "See all businesses \u2192"));
    }
    const b = this.b;
    if (!b) return m(LoadingIndicator, null);
    const v = verifiedText(b.verification);
    const member = b.myStatus === 'active';
    const contact = b.contact || {};
    const team = (b.team || []).filter(t => t.status === 'active');
    const sub = b.subcategories.map(s => s.name).join(', ');
    return m("article", {
      className: "VEvt VEvtD VBizD"
    }, b.approval !== 'approved' ? m("p", {
      className: 'VEvt-status is-' + b.approval
    }, b.approval === 'pending' ? 'Waiting for approval: only its people and moderators can see this page.' : 'Not listed: ' + (b.approvalNote || 'a moderator sent it back.') + ' Edit it and it goes back for review.') : null, b.myStatus === 'invited' ? m("div", {
      className: "VBiz-invite"
    }, m("span", null, "You\u2019re invited to join ", b.name, " as ", b.myRole === 'owner' ? 'an owner' : 'part of the team', "."), m("span", {
      className: "VEvt-actions"
    }, m(Button, {
      className: "Button Button--primary",
      loading: this.busy === '/accept',
      onclick: () => this.act('POST', '/accept', null, () => this.load())
    }, "Join"), m(Button, {
      className: "Button",
      onclick: () => this.act('DELETE', '/members/' + app.session.user.id(), null, () => m.route.set('/businesses'))
    }, "Decline"))) : null, m("div", {
      className: "VEvtD-bar"
    }, m("a", {
      href: "/businesses",
      onclick: go('/businesses')
    }, "\u2190 Businesses"), m("span", null, b.approval === 'approved' ? m(Button, {
      className: "Button",
      icon: this.copied ? 'fas fa-check' : 'far fa-copy',
      onclick: () => this.copy()
    }, this.copied ? 'Copied' : 'Copy link') : null, b.canEdit || b.canModerate ? m(Button, {
      className: "Button",
      icon: "fas fa-pen",
      onclick: go('/businesses/' + b.slug + '?edit=1')
    }, "Edit") : null)), m("div", {
      className: "VEvtD-layout VBizD-layout"
    }, m("div", {
      className: "VEvtD-side"
    }, logo(b, 0)), m("div", {
      className: "VEvtD-main"
    }, b.place ? m("div", {
      className: "VBizD-where"
    }, this.placeLink(b), b.stateSlug ? m("a", {
      className: "VEvtD-place",
      href: '/data-hub/states/' + b.stateSlug,
      onclick: go('/data-hub/states/' + b.stateSlug)
    }, m("i", {
      className: "fas fa-chart-simple",
      "aria-hidden": "true"
    }), " ", b.stateName, " in the Data Hub \u203A") : null) : null, m("h1", null, b.name, v ? m("i", {
      className: "fas fa-circle-check VBiz-tick",
      title: v,
      "aria-label": "Verified"
    }) : null), m("span", {
      className: "VEvtD-by"
    }, m("span", {
      className: 'VBiz-status VBiz-status--' + b.operatingStatus
    }, "\u25CF ", statusLabel[b.operatingStatus]), team.length ? ' · Run by ' + team.filter(t => t.role === 'owner').map(t => t.displayName || t.username).join(', ') : ''), m("div", {
      className: "VEvtD-facts"
    }, b.category ? m("div", {
      className: "VEvtD-fact"
    }, m("span", {
      className: "VEvtD-icon"
    }, m("i", {
      className: b.category.icon || 'fas fa-briefcase',
      "aria-hidden": "true"
    })), m("span", null, m("strong", null, b.category.name), sub ? m("small", null, sub) : null)) : null, b.yearEstablished ? m("div", {
      className: "VEvtD-fact"
    }, m("span", {
      className: "VEvtD-cal"
    }, m("small", null, "EST."), m("b", null, String(b.yearEstablished).slice(2))), m("span", null, m("strong", null, "Since ", b.yearEstablished), m("small", null, b.yearsOperating ? b.yearsOperating + (b.yearsOperating === 1 ? ' year' : ' years') + ' in business' : 'New this year'))) : null, m("div", {
      className: "VEvtD-fact"
    }, m("span", {
      className: 'VEvtD-icon' + (v ? ' VBiz-verifiedIcon' : '')
    }, m("i", {
      className: v ? 'fas fa-circle-check' : 'fas fa-shield-halved',
      "aria-hidden": "true"
    })), m("span", null, m("strong", null, v ? 'Verified' : 'Not verified'), m("small", null, v ? (b.verification.kind || 'Registration') + ' checked by Voucha' : b.verification.status === 'pending' ? 'Being checked' : 'Registration not checked yet')))), this.vouchCard(b, contact), b.about ? m("section", {
      className: "VEvtD-about"
    }, m("h3", null, "About"), m("p", null, b.about)) : null, this.pills('Services', b.services), this.pills('Products', b.products), this.pills('Areas served', b.serviceAreas), contact.email || contact.phone || contact.url ? m("section", {
      className: "VEvtD-about"
    }, m("h3", null, "Contact"), m("div", {
      className: "VBizD-contact"
    }, contact.url ? m("a", {
      href: contact.url,
      target: "_blank",
      rel: "noopener nofollow"
    }, m("i", {
      className: "fas fa-globe",
      "aria-hidden": "true"
    }), " ", contact.url.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, ''), " \u2197") : null, contact.email ? m("a", {
      href: 'mailto:' + contact.email
    }, m("i", {
      className: "far fa-envelope",
      "aria-hidden": "true"
    }), " ", contact.email) : null, contact.phone ? m("a", {
      href: 'tel:' + contact.phone.replace(/[^0-9+]/g, '')
    }, m("i", {
      className: "fas fa-phone",
      "aria-hidden": "true"
    }), " ", contact.phone) : null)) : null, team.length ? m("section", {
      className: "VEvtD-about"
    }, m("h3", null, "People"), m("div", {
      className: "VBizD-people"
    }, team.map(t => m("a", {
      href: app.route('user', {
        username: t.username
      })
    }, person(t), m("span", null, m("strong", null, t.displayName || t.username), m("small", null, t.role === 'owner' ? 'Owner' : 'Team')))))) : null, m("section", {
      className: "VEvtD-about"
    }, m("h3", null, "Updates", b.postCount ? ' (' + b.postCount + ')' : ''), member ? this.postUpdate() : null, this.postsView(b, member)), b.vouches && b.vouches.length ? m("section", {
      className: "VEvtD-about"
    }, m("h3", null, "Vouches (", b.vouchCount, ")"), m("div", {
      className: "VBizD-vouches"
    }, b.vouches.map(x => m("a", {
      href: app.route('user', {
        username: x.user.username
      })
    }, person(x.user), m("span", null, m("strong", null, x.user.displayName || x.user.username), x.note ? m("small", null, "\u201C", x.note, "\u201D") : null))))) : null, b.canEdit ? this.teamAdmin(b) : null, m("p", {
      className: "VEvt-note"
    }, "Listed by a member and checked by Voucha\u2019s moderators. ", VOUCH_NOTE))));
  }

  /** The place, linking to its most specific location tag (its city's, its state's or its country's) */
  placeLink(b) {
    const tag = (b.places || [])[(b.places || []).length - 1];
    const inner = [m("i", {
      className: "fas fa-location-dot",
      "aria-hidden": "true"
    }), ' ', m("b", null, b.place), tag ? ' ›' : ''];
    if (!tag) return m("span", {
      className: "VEvtD-place"
    }, inner);
    const href = app.route('tag', {
      tags: tag.slug
    });
    return m("a", {
      className: "VEvtD-place",
      href: href,
      onclick: go(href)
    }, inner);
  }
  vouchCard(b, contact) {
    const n = b.vouchCount;
    return m("section", {
      className: "VEvtD-card"
    }, m("h3", null, "Vouches"), m("div", {
      className: "VEvtD-cardBody"
    }, m("small", null, "Members who vouch for ", b.name), m("p", {
      className: "VEvtD-price"
    }, m("i", {
      className: "fas fa-thumbs-up",
      "aria-hidden": "true"
    }), " ", n), m("div", {
      className: "VEvtD-cardButtons"
    }, b.canVouch ? b.vouched ? m(Button, {
      className: "Button Button--primary VBiz-vouched",
      icon: "fas fa-check",
      loading: this.busy === '/vouch',
      onclick: () => this.act('DELETE', '/vouch')
    }, "You vouched \xB7 Undo") : m(Button, {
      className: "Button Button--primary",
      icon: "far fa-thumbs-up",
      onclick: () => this.vouching = !this.vouching
    }, "Vouch for ", b.name) : !app.session.user ? m(Button, {
      className: "Button Button--primary",
      onclick: () => {
        const s = document.querySelector('.item-logIn .Button, .item-logIn button');
        if (s) s.click();
      }
    }, "Log in to vouch") : null, contact.url ? m("a", {
      className: "Button",
      href: contact.url,
      target: "_blank",
      rel: "noopener nofollow"
    }, "Website \u2197") : null), this.vouching && !b.vouched ? m("div", {
      className: "VBizD-vouchBox"
    }, m("textarea", {
      className: "FormControl",
      maxLength: 280,
      rows: 2,
      placeholder: "Optional: how do you know their work?",
      value: this.note,
      oninput: e => this.note = e.target.value
    }), m("small", null, VOUCH_NOTE), m(Button, {
      className: "Button Button--primary",
      loading: this.busy === '/vouch',
      onclick: () => this.act('POST', '/vouch', {
        note: this.note.trim() || null
      }, () => this.vouching = false)
    }, "Vouch")) : null, this.msg && !b.canEdit ? m("p", {
      className: "VBiz-error"
    }, this.msg) : null));
  }
  pills(title, items) {
    if (!items || !items.length) return null;
    return m("section", {
      className: "VEvtD-about"
    }, m("h3", null, title), m("div", {
      className: "VBiz-pills"
    }, items.map(x => m("span", {
      className: "VBiz-pill"
    }, x))));
  }
  postsView(b, member) {
    if (this.posts === null || this.posts === undefined) return m(LoadingIndicator, null);
    if (!this.posts.length) return m("p", {
      className: "VBiz-muted"
    }, "No updates yet.");
    return m("ul", {
      className: "VBizD-posts"
    }, this.posts.map(d => m("li", null, m("a", {
      href: app.route.discussion(d)
    }, m("strong", null, d.title()), m("small", null, d.user() ? d.user().displayName() + ' · ' : '', humanTime(d.createdAt()), " \xB7 ", Math.max(0, d.commentCount() - 1) === 1 ? '1 reply' : Math.max(0, d.commentCount() - 1) + ' replies')), member || b.canModerate ? m("button", {
      type: "button",
      className: "VBizD-unlink",
      title: "Take this off the business\u2019s updates",
      "aria-label": "Take this off the updates",
      onclick: () => this.act('DELETE', '/discussions/' + d.id(), null, () => this.loadPosts())
    }, m("i", {
      className: "fas fa-xmark"
    })) : null)));
  }

  /** Owners and team: start a discussion that becomes the update, or post one they already wrote */
  postUpdate() {
    const me = app.session.user;
    if (this.mine === null) {
      this.mine = [];
      app.store.find('discussions', {
        filter: {
          author: me.username()
        },
        sort: '-createdAt',
        page: {
          limit: 15
        }
      }).then(l => this.mine = l || []).then(() => m.redraw()).catch(() => {});
    }
    const linked = new Set((this.posts || []).map(d => d.id()));
    const options = this.mine.filter(d => !linked.has(d.id()));
    return m("div", {
      className: "VEvtF-block VBizD-post"
    }, m("div", {
      className: "VBizD-postTop"
    }, m("span", null, m("strong", null, "Post an update"), m("small", null, "It shows here and in the discussions.")), m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-pen",
      onclick: () => this.compose()
    }, "New discussion")), options.length ? m("div", {
      className: "VBizD-postPick"
    }, m("select", {
      className: "VBiz-select",
      value: this.pick || '',
      onchange: e => this.pick = e.target.value,
      "aria-label": "One of your discussions"
    }, m("option", {
      value: ""
    }, "Or add one you\u2019ve posted\u2026"), options.map(d => m("option", {
      value: d.id()
    }, d.title()))), m(Button, {
      className: "Button",
      disabled: !this.pick,
      loading: this.busy === '/discussions',
      onclick: () => this.act('POST', '/discussions', {
        discussionId: Number(this.pick)
      }, () => {
        this.pick = '';
        this.loadPosts();
      })
    }, "Add")) : null);
  }

  /** A new discussion that becomes this business's update once it's posted (see linkNewDiscussion in util.js) */
  compose() {
    const b = this.b;
    app.composer.load(() => flarum.reg.asyncModuleImport('flarum/forum/components/DiscussionComposer'), {
      user: app.session.user
    }).then(loaded => {
      if (!loaded) return; // they kept the unsaved draft in the open composer
      try {
        sessionStorage.setItem('vbizPending', JSON.stringify({
          id: b.id,
          slug: b.slug,
          name: b.name,
          at: Date.now()
        }));
      } catch (e) {}
      app.composer.show();
    });
    this.mine = null;
  }
  teamAdmin(b) {
    const all = b.team || [];
    const owners = all.filter(t => t.status === 'active' && t.role === 'owner').length;
    return m("section", {
      className: "VEvtD-about VBizD-team"
    }, m("h3", null, "Manage team"), b.needsPartner ? m("p", {
      className: "VEvt-status is-pending VBizD-partner"
    }, "Add a second person: every business needs at least two, so it\u2019s never left without someone who can look after it.") : null, all.map(t => {
      const lastOwner = t.role === 'owner' && t.status === 'active' && owners === 1;
      return m("div", {
        className: "VBizD-teamRow"
      }, person(t), m("span", {
        className: "VBizD-teamName"
      }, m("strong", null, t.displayName || t.username, t.me ? ' (you)' : ''), m("small", null, t.status === 'invited' ? 'Invited · waiting for them to join' : lastOwner ? 'The only owner' : '')), m("select", {
        className: "VBiz-select",
        value: t.role,
        disabled: lastOwner,
        onchange: e => this.act('POST', '/role', {
          userId: t.id,
          role: e.target.value
        }, () => this.load()),
        "aria-label": 'Role for ' + t.username
      }, m("option", {
        value: "owner"
      }, "Owner"), m("option", {
        value: "team"
      }, "Team")), !lastOwner ? m("button", {
        type: "button",
        className: "VBizD-unlink",
        title: t.me ? 'Leave' : t.status === 'invited' ? 'Cancel the invitation' : 'Remove',
        onclick: () => (t.me ? confirm('Leave ' + b.name + '?') : true) && this.act('DELETE', '/members/' + t.id, null, () => t.me ? m.route.set('/businesses') : this.load())
      }, m("i", {
        className: "fas fa-xmark"
      })) : m("span", {
        className: "VBizD-unlinkSpace"
      }));
    }), (b.emailInvites || []).map(x => m("div", {
      className: "VBizD-teamRow is-email"
    }, m("span", {
      className: "Avatar VBiz-avatar"
    }, m("i", {
      className: "far fa-envelope"
    })), m("span", {
      className: "VBizD-teamName"
    }, m("strong", null, x.email), m("small", null, "Invited by email as ", x.role === 'team' ? 'team' : 'an owner', " \xB7 waiting for them to join Voucha")), m("button", {
      type: "button",
      className: "VBizD-unlink",
      title: "Cancel the invitation",
      onclick: () => this.act('DELETE', '/email-invites/' + x.id)
    }, m("i", {
      className: "fas fa-xmark"
    })))), m("form", {
      className: "VBizD-inviteForm",
      onsubmit: e => {
        e.preventDefault();
        const who = this.inviteName.trim();
        if (!who) return;
        const email = /@/.test(who) && !/^@/.test(who);
        this.act('POST', '/invite', email ? {
          email: who,
          role: this.inviteRole
        } : {
          username: who.replace(/^@/, ''),
          role: this.inviteRole
        }, r => {
          this.inviteName = '';
          if (r && r.message) app.alerts.show({
            type: 'success'
          }, r.message);
          this.load();
        });
      }
    }, m("input", {
      className: "VBiz-select",
      placeholder: "Username, or email if not on Voucha",
      value: this.inviteName,
      oninput: e => this.inviteName = e.target.value,
      "aria-label": "Username or email"
    }), m("select", {
      className: "VBiz-select",
      value: this.inviteRole,
      onchange: e => this.inviteRole = e.target.value,
      "aria-label": "Role"
    }, m("option", {
      value: "team"
    }, "as Team"), m("option", {
      value: "owner"
    }, "as Owner")), m(Button, {
      className: "Button Button--primary",
      type: "submit",
      disabled: !this.inviteName.trim(),
      loading: this.busy === '/invite'
    }, "Invite")), this.msg ? m("p", {
      className: "VBiz-error"
    }, this.msg) : null, m("small", {
      className: "VBiz-muted"
    }, "Members see the invitation on the Businesses page and in the app. People not on Voucha get an email with a link to join."));
  }
}
flarum.reg.add('voucha-community', 'forum/businesses/BusinessView', BusinessView);